<template>
    <div>
        <slot name="header" :columns="datatable.columns"></slot>
        <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
            <ValidationObserver ref="formModalValidate">
                <b-row>
                    <b-col md="6">
                        <ValidationProvider name="date" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('date')">
                                    <select-date :validation-error="errors[0]" v-model="datatable.queryParams.filter.date"/>
                            </b-form-group>
                        </ValidationProvider>
<!--                            <ValidationProvider name="date" rules="required" v-slot="{valid, errors}">-->
<!--                                <v-date-picker v-model="datatable.queryParams.filter.date"-->
<!--                                               is-range-->
<!--                                               :model-config="{type: 'string', mask: 'YYYY-MM-DD'}"-->
<!--                                >-->
<!--                                    <template v-slot="{ inputValue, inputEvents }">-->
<!--                                        <div class="border rounded-sm p-1 p-md-3 d-flex align-items-center" :class="errors[0] ? 'box-border-color':''">-->
<!--                                            <div class="flex-grow-1">-->
<!--                                                <b-form-group class="m-0 mr-1">-->
<!--                                                    <input :value="inputValue.start"-->
<!--                                                           v-on="inputEvents.start"-->
<!--                                                           :placeholder="$t('start_date')"-->
<!--                                                           class="form-control"-->
<!--                                                    />-->
<!--                                                </b-form-group>-->
<!--                                            </div>-->
<!--                                            <div class="flex-grow-1">-->
<!--                                                <b-form-group class="m-0 ml-1">-->
<!--                                                    <input :value="inputValue.end"-->
<!--                                                           v-on="inputEvents.end"-->
<!--                                                           :placeholder="$t('end_date')"-->
<!--                                                           class="form-control"-->
<!--                                                    />-->
<!--                                                </b-form-group>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>-->
<!--                                    </template>-->
<!--                                </v-date-picker>-->
<!--                            </ValidationProvider>-->

                    </b-col>
                    <b-col md="6">
                        <ValidationProvider name="time" rules="required" v-slot="{valid, errors}">
                            <b-form-group :label="$t('start_time')+' / '+$t('end_time')">
                                <time-picker v-model="datatable.queryParams.filter.time"
                                             :minute-increment="5"
                                             :validate-error="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <ValidationProvider name="campus_id" v-slot="{valid, errors}">
                            <b-form-group :label="$t('campus')">
                                <campus-selectbox v-model="datatable.queryParams.filter.campus_id"
                                                  :validate-error="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <ValidationProvider name="building_id" v-slot="{valid, errors}">
                            <b-form-group :label="$t('building')">
                                <building-selectbox v-model="datatable.queryParams.filter.building_id"
                                                    :campus_id="datatable.queryParams.filter.campus_id"
                                                    :validate-error="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <ValidationProvider name="classroom_id" v-slot="{valid, errors}">
                            <b-form-group :label="$t('classroom')">
                                <classroom-selectbox
                                    v-model="datatable.queryParams.filter.classroom_id"
                                    :building_id="datatable.queryParams.filter.building_id"
                                    :campus_id="datatable.queryParams.filter.campus_id"
                                    :validate-error="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('classroom_types')">
                            <parameter-selectbox
                                code="classroom_types"
                                v-model="datatable.queryParams.filter.type"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('seating_types')">
                            <parameter-selectbox
                                code="seating_types"
                                v-model="datatable.queryParams.filter.seating_type"
                            />
                        </b-form-group>
                    </b-col>
<!--                    <b-col cols="12" md="6">-->
<!--                        <b-form-group :label="$t('board_types')">-->
<!--                            <parameter-selectbox-->
<!--                                code="board_types"-->
<!--                                v-model="datatable.queryParams.filter.board_type"-->
<!--                            />-->
<!--                        </b-form-group>-->
<!--                    </b-col>-->
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('display_systems')">
                            <parameter-selectbox
                                code="display_systems"
                                v-model="datatable.queryParams.filter.display_system"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('sound_systems')">
                            <parameter-selectbox
                                code="sound_systems"
                                v-model="datatable.queryParams.filter.sound_system"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('hybrid_statuses')">
                            <parameter-selectbox v-model="datatable.queryParams.filter.hybrid_status"
                                                 code="hybrid_statuses"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-form-group :label="$t('technological_materials')">
                            <parameter-selectbox v-model="datatable.queryParams.filter.technological_material"
                                                 code="technological_materials"
                            />
                        </b-form-group>
                    </b-col>

                </b-row>
            </ValidationObserver>
        </datatable-filter>
        <datatable :isLoading.sync="datatable.isLoading"
                   :columns="datatable.columns"
                   :rows="datatable.rows"
                   :total="datatable.total"
                   :queryParams="datatable.queryParams"
                   @on-page-change="onPageChange"
                   @on-sort-change="onSortChange"
                   @on-per-page-change="onPerPageChange"
                   v-show="datatable.showTable"
        />
    </div>
</template>
<script>
// Component
import DatatableFilter from '@/components/datatable/DatatableFilter'
import Datatable from '@/components/datatable/Datatable'
import SelectDate from '@/components/interactive-fields/SelectDate'
import ClassroomSelectbox from "@/components/interactive-fields/ClassroomSelectbox.vue";
import BuildingSelectbox from '@/components/interactive-fields/BuildingSelectbox'
import CampusSelectbox from '@/components/interactive-fields/CampusSelectbox'
import TimePicker from '@/components/elements/TimePicker'
// Services

import ReservationService from '@/services/ReservationService'
// Other
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import qs from 'qs'

export default {
    components: {
        ClassroomSelectbox,
        ValidationProvider,
        ValidationObserver,

        BuildingSelectbox,
        CampusSelectbox,
        DatatableFilter,
        Datatable,
        SelectDate,
        TimePicker
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('reservation_add'),
                                class: 'ri-add-line',
                                permission: 'reservation_store',
                                hidden: false,
                                callback: (row) => {
                                    this.$emit('createFormShow', {
                                        campus_id: row.campus_id,
                                        building_id: row.building_id,
                                        classroom_id: row.id,
                                        date: this.datatable.queryParams.filter.date,
                                        time: this.datatable.queryParams.filter.time
                                    })
                                }
                            }
                        ]
                    },
                    {
                        label: this.toUpperCase(this.spaceToBR(this.$t('campus'))),
                        field: 'campus_name',
                        sortable: false,
                        formatFn: (value, row) => {
                            return this.getLocaleText(row, 'campus_name', '-')
                        },
                        hidden:false
                    },
                    {
                        label: this.toUpperCase(this.$t('building')),
                        field: this.getLocaleField('building_name'),
                        sortable: false,
                        hidden:false
                    },
                    {
                        label: this.toUpperCase(this.$t('classroom_name')),
                        field: this.getLocaleField('name'),
                        sortable: false,
                        thClass: 'text-center',
                        tdClass: 'text-center',
                        hidden:false
                    },
                    {
                        label: this.toUpperCase(this.$t('classroom_types')),
                        field: this.getLocaleField('type_name'),
                        sortable: false,
                        thClass: 'text-center',
                        tdClass: 'text-center',
                        hidden:false
                    },
                    {
                        label: this.toUpperCase(this.$t('seating_types')),
                        field: this.getLocaleField('seating_type_name'),
                        sortable: false,
                        thClass: 'text-center',
                        tdClass: 'text-center',
                        hidden:true
                    },
                    // {
                    //     label: this.toUpperCase(this.$t('board_types')),
                    //     field: 'board_type',
                    //     sortable: false,
                    //     thClass: 'text-center',
                    //     tdClass: 'text-center',
                    //     hidden:true
                    // },
                    {
                        label: this.toUpperCase(this.$t('display_systems')),
                        field: this.getLocaleField('display_system_name'),
                        sortable: false,
                        thClass: 'text-center',
                        tdClass: 'text-center',
                        hidden:true
                    },
                    {
                        label: this.toUpperCase(this.$t('sound_systems')),
                        field: this.getLocaleField('sound_system_name'),
                        sortable: false,
                        thClass: 'text-center',
                        tdClass: 'text-center',
                        hidden:true
                    },
                    {
                        label: this.toUpperCase(this.$t('hybrid_statuses')),
                        field: this.getLocaleField('hybrid_status_name'),
                        sortable: false,
                        thClass: 'text-center',
                        tdClass: 'text-center',
                        hidden:true
                    },
                    {
                        label: this.toUpperCase(this.$t('technological_materials')),
                        field: this.getLocaleField('technological_material_name'),
                        sortable: false,
                        thClass: 'text-center',
                        tdClass: 'text-center',
                        hidden:true
                    },
                    {
                        label: this.toUpperCase(this.$t('classroom')),
                        field: 'capacity',
                        sortable: false,
                        thClass: 'text-center',
                        tdClass: 'text-center',
                        hidden:false
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {
                        date: null,
                        time: null,
                        campus_id: null,
                        classroom_id: null,
                        building_id: null,
                        type: null,
                        seating_type: null,
                        board_type: null,
                        display_system: null,
                        sound_system: null,
                        hybrid_status: null,
                        technological_material: null,
                    },
                    page: 1,
                    limit: 20
                }
            }
        }
    },
    mounted() {
        this.$emit('send-columns', this.datatable.columns);
    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {
                date: null,
                time: null
            }
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        async getRows() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                // Filters
                let filters = {
                    ...this.datatable.queryParams.filter
                }

                // Modify Filters
                let modifyFilters = {}


                // Time
                if (filters.time) {
                    modifyFilters.start_time = filters.time.start
                    modifyFilters.end_time = filters.time.end
                }

                const config = {
                    params: {
                        date:filters.date,
                        filter: {
                            campus_id: filters.campus_id,
                            building_id: filters.building_id,
                            id: filters.classroom_id,
                            type: filters.type,
                            seating_type: filters.seating_type,
                            board_type: filters.board_type,
                            display_system: filters.display_system,
                            sound_system: filters.sound_system,
                            hybrid_status: filters.hybrid_status,
                            technological_material: filters.technological_material,

                        },
                        ...modifyFilters,
                        sort: this.datatable.queryParams.sort,
                        page: this.datatable.queryParams.page,
                        limit: this.datatable.queryParams.limit
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return ReservationService.emptyClassrooms(config)
                    .then((response) => {
                        this.datatable.rows = response.data.data;
                        this.datatable.total = response.data.pagination.total;
                    })
                    .catch((e) => {
                        this.showErrors(e,this.$refs.formModalValidate);
                    })
                    .finally(() => {
                        this.datatable.isLoading = false;
                    });
            }
        }
    }
}
</script>
